module.exports = __webpack_public_path__ + "static/media/banner-photo1024@2x.9543dfde.jpg";